import { render, staticRenderFns } from "./DieticianAdviceStatus.vue?vue&type=template&id=7ca9676f&scoped=true&"
import script from "./DieticianAdviceStatus.vue?vue&type=script&lang=js&"
export * from "./DieticianAdviceStatus.vue?vue&type=script&lang=js&"
import style0 from "./DieticianAdviceStatus.vue?vue&type=style&index=0&id=7ca9676f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca9676f",
  null
  
)

export default component.exports